import { animate, style, transition, trigger } from '@angular/animations';

export const ZOOM_IN = trigger('zoom', [
  transition(':enter', [
    style({ opacity: 0, transform: 'scale(0.9)' }),
    animate('200ms ease-in-out', style({ opacity: 1, transform: '*' }))
  ])
]);
